export enum SocialMediaTypes {
    TWITTER = 'twitter',
    YOUTUBE = 'youtube',
    FACEBOOK = 'facebook',
    INSTAGRAM = 'instagram',
    TIKTOK = 'tiktok',
    UNKNOWN = 'unknown'
}
